import { ILeadEditState } from "../interfaces/ILead";

export default () => (values: ILeadEditState) => {
    const errors: Record<string, string> = {};

    if (values.isSetReminder) {
        if (!values.activityDueDate)
            errors.activityDueDate = "Required";
        if (!values.activitySubject?.trim())
            errors.activitySubject = "Required";
    }

    return errors;
};